import { useEffect } from 'react'
import { useInformalFeedbackRequests } from 'hooks/useInformalFeedbackRequests'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useDispatch } from 'react-redux'
import { upsertInformalFeedbackRequest } from 'redux/actions/informalFeedbackRequests'
import { useQueryClient } from 'react-query'
import { informalFeedbackRequestsKeys } from './queries/informalFeedbackRequests/informalFeedbackRequestsKeys'
import { InformalFeedbackRequest } from '../api/clients/InformalFeedbackRequestsClient'
import { useArticlePassword } from './useArticlePassword'

const WS_CHANNEL_NAME = 'Workflows::InformalFeedbackRequestChannel'

// TODO: Delete and replace once reviews as sharing is released
export const useInformalFeedbackRequestRealtimeChannel = (articleKey: string, layerId: string) => {
  const websocketConnection = useWebsocketConnection()
  const queryClient = useQueryClient()
  const password = useArticlePassword(articleKey)
  const { informalFeedbackRequests } = useInformalFeedbackRequests(articleKey, layerId)
  const openRequest = informalFeedbackRequests[0]
  const dispatch = useDispatch()

  useEffect(() => {
    if (!openRequest || !websocketConnection) {
      return
    }

    const subscription = websocketConnection.subscriptions.create(
      {
        channel: WS_CHANNEL_NAME,
        id: openRequest.id,
      },
      {
        received: (data: { informal_feedback_request: InformalFeedbackRequest }) => {
          const request = data.informal_feedback_request
          queryClient.invalidateQueries([informalFeedbackRequestsKeys.prefix, request.article.key])
          dispatch(upsertInformalFeedbackRequest(request))
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [websocketConnection, openRequest, dispatch, queryClient, password])
}
